<template>
  <div>
    <v-dialog
      v-model="productDiscountDialogActive"
      persistent
      max-width="900"
      class="discount-dialog"
    >
      <v-flex xs12 class="discount-dialog_container">
        <!-- Title of dialog -->
        <v-layout row class="mt-4">
          <v-icon
            class="ml-4 mt-4"
            :style="`color: ${$vuetify.theme.primary}`"
            large
            >format_list_bulleted</v-icon
          >
          <h1 :style="`color: ${$vuetify.theme.primary}`" class="ml-3 mt-4">
            {{ $translate("DISCOUNT") }}
          </h1>
          <v-spacer></v-spacer>
          <v-btn
            round
            color="primary"
            class="mr-4 mt-4"
            @click="closeProductDiscountDialog"
          >
            <v-icon x-large dark>close</v-icon>
          </v-btn>
        </v-layout>

        <v-divider class="mt-4"></v-divider>
        <v-subheader>Product price</v-subheader>

        <!-- Price of product -->
        <v-layout row align-center justify-space-around class="my-4">
          <!-- Original price -->
          <v-flex xs4>
            <v-layout row align-center>
              <h3>{{ $translate("ORIGINAL_PRICE") }}</h3>
              <h5 class="requiredField">- {{ $translate("REQUIRED") }}</h5>
            </v-layout>
            <v-text-field
              outline
              prepend-inner-icon="€"
              :label="$translate('ORIGINAL_PRICE')"
              v-model="originalPrice"
              type="number"
              :rules="priceRule"
              required
            ></v-text-field>
          </v-flex>
          <!-- Discount price -->
          <v-flex xs4>
            <v-layout row align-center>
              <h3>{{ $translate("DISCOUNT_PRICE") }}</h3>
              <h5 class="requiredField">- {{ $translate("REQUIRED") }}</h5>
            </v-layout>
            <v-text-field
              outline
              prepend-inner-icon="€"
              :label="$translate('DISCOUNT_PRICE')"
              v-model="discountPrice"
              type="number"
              :rules="priceRule"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>

        <!-- Only when there are more than 1 item, the following selection part would be shown -->
        <template v-if="product.Items.length > 1">
          <v-divider></v-divider>
          <v-subheader>Apply discount to product items</v-subheader>

          <!-- Filter of aspects -->
          <!-- <v-layout align-center justify-space-around row>
          <v-flex xs4>
            <v-combobox
              v-model="productAspectsSelected"
              :items="productAspects"
              item-text="DefValue"
              label="Filter on product aspects"
              multiple
              return-object
            >
              <template v-slot:item="{item}">
                  <v-divider v-if="item.DefName === item.DefValue" :key="item.DefValue"></v-divider>
                  <v-subheader v-if="item.DefName === item.DefValue">{{ aspectItem.DefName }}</v-subheader>
                  <v-list-tile v-if="item.DefName !== item.DefValue">
                    <v-list-title-content>
                      {{ item.DefValue }}
                    </v-list-title-content>
                  </v-list-tile>
              </template>

              <template v-slot:selection="data">
                <v-chip
                  :key="JSON.stringify(data.item.DefValue)"
                  :selected="data.selected"
                  :disabled="data.disabled"
                  class="v-chip--select-multi"
                  @input="data.parent.selectItem(data.item)"
                >
                  <v-avatar
                    class="accent white--text"
                    v-text="data.item.DefValue.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                  {{ data.item.DefValue }}
                </v-chip>
              </template>
            </v-combobox>
          </v-flex>
          <v-flex xs4></v-flex>
        </v-layout> -->

          <!-- Item lists -->
          <v-layout align-center justify-space-around row>
            <v-spacer></v-spacer>
            <!-- Item list without discount -->
            <v-flex xs4>
              <v-layout column>
                <h3 :style="`color: ${$vuetify.theme.primary}`">
                  {{ $translate("PRODUCT_ITEMS_WITHOUT_DISCOUNT") }}
                </h3>
                <div class="elevation-1 discount-dialog_item-list">
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in itemsWithoutDiscount"
                      :key="index"
                      @click=""
                    >
                      <v-list-tile-action>
                        <v-checkbox
                          class="ml-2 mt-4"
                          v-model="item.Selected"
                          @change="
                            selectItemFromItemsWithoutDiscountCheckbox(index)
                          "
                        ></v-checkbox>
                      </v-list-tile-action>

                      <v-list-tile-content
                        class="discount-dialog_item-list_content"
                        @click="selectItemFromItemsWithoutDiscount(index)"
                      >
                        <v-list-tile-title>{{
                          item.ItemDefsStr
                        }}</v-list-tile-title>
                        <!-- <v-list-tile-sub-title>{{item.Id}}</v-list-tile-sub-title> -->
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </div>
                <v-checkbox
                  class="mt-1"
                  label="Select all"
                  v-model="startDiscountOnAllItems"
                  @change="selectAllItemsFromListWithoutDiscount"
                ></v-checkbox>
              </v-layout>
            </v-flex>

            <!-- Arrows to move selected items -->
            <v-flex xs2>
              <v-layout align-center justify-center column>
                <v-btn
                  :disabled="itemsSelectedFromListWithoutDiscount.length === 0"
                  round
                  color="primary"
                  class="text-capitalize"
                  @click="addToItemsWithDiscount"
                >
                  <v-icon large>arrow_forward</v-icon>
                </v-btn>
                <v-btn
                  :disabled="itemsSelectedFromListWithDiscount.length == 0"
                  round
                  color="secondary"
                  class="text-capitalize"
                  @click="addToItemsWithoutDiscount"
                >
                  <v-icon large>arrow_back</v-icon>
                </v-btn>
              </v-layout>
            </v-flex>

            <!-- Item list with discount -->
            <v-flex xs4>
              <v-layout column>
                <h3 :style="`color: ${$vuetify.theme.primary}`">
                  {{ $translate("PRODUCT_ITEMS_WITH_DISCOUNT") }}
                </h3>
                <v-flex class="elevation-1 discount-dialog_item-list">
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in itemsWithDiscount"
                      :key="index"
                      @click=""
                    >
                      <v-list-tile-action>
                        <v-checkbox
                          class="ml-2 mt-4"
                          v-model="item.Selected"
                          @change="
                            selectItemFromItemsWithDiscountCheckbox(index)
                          "
                        ></v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content
                        class="discount-dialog_item-list_content"
                        @click="selectItemFromItemsWithDiscount(index)"
                      >
                        <v-list-tile-title>{{
                          item.ItemDefsStr
                        }}</v-list-tile-title>
                        <!-- <v-list-tile-sub-title>{{item.Id}}</v-list-tile-sub-title> -->
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
                <v-checkbox
                  class="mt-1"
                  label="Select all"
                  v-model="stopDiscountOnAllItems"
                  @change="selectAllItemsFromListWithDiscount"
                ></v-checkbox>
              </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
        </template>

        <!-- Buttons to stop / start discount -->
        <v-layout class="mr-4 mt-4 pb-4" justify-end row>
          <v-btn
            round
            color="secondary"
            class="text-capitalize"
            @click="stopDiscount"
            >{{ $translate("STOP_DISCOUNT") }}</v-btn
          >
          <v-btn
            round
            color="primary"
            class="text-capitalize"
            :disabled="(product.Items.length > 1 && itemsWithDiscount.length === 0) || discountPrice === undefined || discountPrice === null"
            @click="startDiscount"
            >{{ $translate("START_DISCOUNT") }}</v-btn
          >
        </v-layout>
      </v-flex>
    </v-dialog>

    <!-- Dialog when request succeeded -->
    <SuccessDialog
      v-if="successDialogActive"
      :successMsg="successMsg"
      @success-dialog-closed="successDialogClosedHandler"
    />

    <!-- Dialog when request failed -->
    <FailureDialog
      v-if="failureDialogActive"
      :failureMsg="failureMsg"
      @failure-dialog-closed="failureDialogClosedHandler"
    />

    <!-- Dialog when warn occurs -->
    <WarnDialog
      v-if="warnDialogActive"
      :warnMsg="warnMsg"
      @warn-dialog-closed="warnDialogClosedHandler"
    />
  </div>
</template>

<script>
import { ui_helpers } from "../shared/ui_helpers.js";
import * as dssRequest from "../api/dssRequest";
import BaseComponent from "./base/BaseComponent";
import BaseObject from "../objects/BaseObject";
import { store } from "../store";
import SuccessDialog from "@/components/AlertDialogs/SuccessDialog";
import FailureDialog from "@/components/AlertDialogs/FailureDialog";
import WarnDialog from "@/components/AlertDialogs/WarnDialog";

export default {
  name: "ProductDiscountDialog",
  extends: BaseComponent,
  mixins: [ui_helpers],
  components: {
    SuccessDialog,
    FailureDialog,
    WarnDialog
  },
  props: {
    productProp: Object,
    eventId: [String, Number],
  },
  computed: {},
  watch: {
    productAspectsSelected(newVal, oldVal) {
      console.log(
        "productAspectsSelected changed: ",
        this.productAspectsSelected
      );
    },
  },
  data() {
    return {
      productDiscountDialogActive: true,
      product: this.productProp,
      originalPrice: undefined,
      discountPrice: undefined,
      productAspects: [],
      productAspectsSelected: [],
      itemsWithoutDiscount: [],
      itemsWithDiscount: [],
      defaultItem: {},
      itemsSelectedFromListWithoutDiscount: [],
      itemsSelectedFromListWithDiscount: [],
      startDiscountOnAllItems: false,
      stopDiscountOnAllItems: false,
      priceRule: [(v) => (v >= 0) || "Price should be positive"],
      successDialogActive: false,
      failureDialogActive: false,
      warnDialogActive: false,
      successMsg: false,
      failureMsg: false,
      warnMsg: ''
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // Separate items based on Discount flag
      if (this.product !== undefined && this.product.hasOwnProperty("Items")) {
        this.product.Items.forEach((item) => {
          item.ItemDefsStr = "";
          Object.entries(item.ItemDefs).forEach(([key, value]) => {
            item.ItemDefsStr += value + ", ";
          });

          if (item.ItemDefsStr === "") {
            // No ItemDef, this is the default Item
            this.defaultItem = Object.assign(item);
            item.ItemDefsStr = "Default";
          } else {
            // Default item will not be shown
            item.Selected = false;

            if (item.Discount) {
              this.itemsWithDiscount.push(item);
            } else {
              this.itemsWithoutDiscount.push(item);
            }
            
            // Remove the last comma
            let i = item.ItemDefsStr.lastIndexOf(",");
            if (i > -1) {
              item.ItemDefsStr = item.ItemDefsStr.substring(0, i);
            }
          }
        });
      }

      // Get OriginalPrice and DiscountPrice
      // Logic:
      //       If Discount is true, OriginalPrice equals to RetailPrice, DiscountPrice equals to Price
      //       If Discount is false, OriginalPrice equals to Price, DiscountPrice is empty
      if (
        this.product !== undefined &&
        this.product.hasOwnProperty("Discount")
      ) {
        if (this.product.Discount) {
          this.originalPrice = this.product.RetailPrice;
          this.discountPrice = this.product.Price;
        } else {
          this.originalPrice = this.product.Price;
          // this.discountPrice = 0;
        }
      }

      // Get product aspects
      if (
        this.product !== undefined &&
        this.product.hasOwnProperty("ItemDefs")
      ) {
        Object.entries(this.product.ItemDefs).forEach(([key, value]) => {
          let aspectHeader = {
            DefName: key,
            DefValue: key,
          };
          this.productAspects.push(aspectHeader);

          Object.entries(value).forEach(([innerKey, innerValue]) => {
            let aspectObj = {
              DefName: key,
              DefValue: innerValue,
            };
            this.productAspects.push(aspectObj);
          });
        });
      }
    },
    selectItemFromItemsWithoutDiscountCheckbox(index) {
      // Called when the check box in item list without discount is clicked on
      // Either remove or add selected item to the list of itemsSelectedFromListWithoutDiscount
      this.updateItemInItemsWithoutDiscount(index);
    },
    selectItemFromItemsWithoutDiscount(index) {
      this.itemsWithoutDiscount[index].Selected = !this.itemsWithoutDiscount[
        index
      ].Selected;
      this.updateItemInItemsWithoutDiscount(index);
    },
    updateItemInItemsWithoutDiscount(index) {
      const i = this.itemsSelectedFromListWithoutDiscount.findIndex(
        (item) => item.Id === this.itemsWithoutDiscount[index].Id
      );
      if (i > -1) {
        // Item already in the selected list, remove it
        this.itemsSelectedFromListWithoutDiscount.splice(i, 1);
      } else {
        // Item not in the selected list yet, add it
        this.itemsSelectedFromListWithoutDiscount.push(
          this.itemsWithoutDiscount[index]
        );
      }
    },
    selectItemFromItemsWithDiscountCheckbox(index) {
      // Called when the check box in item list with discount is clicked on
      // Either remove or add selected item to the list of itemsSelectedFromListWithDiscount
      this.updateItemInItemsWithDiscount(index);
    },
    selectItemFromItemsWithDiscount(index) {
      this.itemsWithDiscount[index].Selected = !this.itemsWithDiscount[index]
        .Selected;
      this.updateItemInItemsWithDiscount(index);
    },
    updateItemInItemsWithDiscount(index) {
      const i = this.itemsSelectedFromListWithDiscount.findIndex(
        (item) => item.Id === this.itemsWithDiscount[index].Id
      );
      if (i > -1) {
        // Item already in the selected list, remove it
        this.itemsSelectedFromListWithDiscount.splice(i, 1);
      } else {
        // Item not in the selected list yet, add it
        this.itemsSelectedFromListWithDiscount.push(
          this.itemsWithDiscount[index]
        );
      }
    },
    selectAllItemsFromListWithoutDiscount() {
      this.itemsSelectedFromListWithoutDiscount = [];

      if (this.startDiscountOnAllItems) {
        this.itemsWithoutDiscount.forEach((item) => {
          item.Selected = true;
          this.itemsSelectedFromListWithoutDiscount.push(item);
        });
      } else {
        this.itemsWithoutDiscount.forEach((item) => (item.Selected = false));
      }
    },
    selectAllItemsFromListWithDiscount() {
      this.itemsSelectedFromListWithDiscount = [];

      const defaultItemId = this.product.Id + "_DEFAULT";

      if (this.stopDiscountOnAllItems) {
        this.itemsWithDiscount.forEach((item) => {
          if (item.Id !== defaultItemId) {
            item.Selected = true;
            this.itemsSelectedFromListWithDiscount.push(item);
          }
        });
      } else {
        this.itemsWithDiscount.forEach((item) => (item.Selected = false));
      }
    },
    addToItemsWithDiscount() {
      this.itemsSelectedFromListWithoutDiscount.forEach((item) => {
        item.Selected = false;
        item.Discount = true;
        this.itemsWithDiscount.push(item);
        const index = this.itemsWithoutDiscount.findIndex(
          (i) => i.Id == item.Id
        );
        this.itemsWithoutDiscount.splice(index, 1);
      });
      this.itemsSelectedFromListWithoutDiscount = [];
      this.startDiscountOnAllItems = false;
      this.stopDiscountOnAllItems = false;
    },
    addToItemsWithoutDiscount() {
      this.itemsSelectedFromListWithDiscount.forEach((item) => {
        item.Selected = false;
        item.Discount = false;
        this.itemsWithoutDiscount.push(item);
        const index = this.itemsWithDiscount.findIndex((i) => i.Id == item.Id);
        this.itemsWithDiscount.splice(index, 1);
      });
      this.itemsSelectedFromListWithDiscount = [];
      this.startDiscountOnAllItems = false;
      this.stopDiscountOnAllItems = false;
    },
    stopDiscount() {
      const payload = {
        ProductId: this.product.Id,
      };

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The carequest [stopDiscount] to Event [%s] in component [ProductDiscountDialog] succeeded",
            this.eventId,
            response
          );

          this.successMsg =
            "Your request to stop discount on the product has been processed successfully.";
          this.successDialogActive = true;
        },
        (error) => {
          console.log(
            "The carequest [stopDiscount] to Event [%s] in component [ProductDiscountDialog] failed",
            this.eventId,
            error
          );

          this.failureMsg =
            "Your request to stop discount on the product failed. Please try again later. If the problem persists, please contact the administrator.";
          this.failureDialogActive = true;
        },
        "stopDiscount",
        this.eventId,
        payload
      );
    },
    startDiscount() {
      // Evaluate the form
      if(this.discountPrice === undefined || this.discountPrice === null || this.discountPrice < 0) {
        this.warnMsg = "Please fill in a valid discount price";
        this.warnDialogActive = true;
        return;
      }

      const payload = {
        ProductId: this.product.Id,
        OriginalPrice: Number(this.originalPrice),
        DiscountPrice: Number(this.discountPrice),
        Items: [],
      };

      this.itemsWithDiscount.forEach((item) => payload.Items.push(item.Id));

      // Add it to the list
      payload.Items.push(this.defaultItem.Id);

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The carequest [startDiscount] to Event [%s] in component [ProductDiscountDialog] succeeded",
            this.eventId,
            response
          );

          this.successMsg =
            "Your request to start discount on the product has been processed successfully.";
          this.successDialogActive = true;
        },
        (error) => {
          console.log(
            "The carequest [startDiscount] to Event [%s] in component [ProductDiscountDialog] failed",
            this.eventId,
            error
          );

          this.failureMsg =
            "Your request to start discount on the product failed. Please try again later. If the problem persists, please contact the administrator.";
          this.failureDialogActive = true;
        },
        "startDiscount",
        this.eventId,
        payload
      );
    },
    successDialogClosedHandler() {
      this.successDialogActive = false;
      this.productDiscountDialogActive = false;
      this.$emit("product-discount-updated", this.itemsWithDiscount);
    },
    failureDialogClosedHandler() {
      this.failureDialogActive = false;
      this.productDiscountDialogActive = false;
      this.$emit("product-discount-dialog-closed");
    },
    closeProductDiscountDialog() {
      this.productDiscountDialogActive = false;
      this.$emit("product-discount-dialog-closed");
    },
    warnDialogClosedHandler() {
      this.warnDialogActive = false;
    }
  },
};
</script>

<style>
.discount-dialog {
  overflow-x: hidden;
  overflow-y: hidden;
  min-height: 200px;
}

.discount-dialog_container {
  background-color: #ffffff;
  border-radius: 1em;
}

.discount-dialog_item-list {
  /* margin-right: 1em; */
  border: 1.5px solid black;
  min-height: 30em;
  max-height: 30em;
  max-width: 20em !important;
  overflow-x: hidden;
  overflow-y: auto;
}

.discount-dialog_item-list_content {
  border-bottom: 1px solid black;
  text-overflow: ellipsis;
  /* margin-left: -0.5em;
  margin-right: -0.5em; */
}

.listOutlineUserGroupDialog {
  margin-top: 1em;
  /* margin-left: 2.6em; */
}
</style>
